// lib
import { connect } from "react-redux";
// src
import Component from "components/Root";

const mapStateToProps = ({
  system: { isHydrated },
  table: { isLoadingInRange },
  user: { idop },
}) => ({
  idop,
  isHydrated,
  isLoading: isLoadingInRange,
});

export default connect(mapStateToProps)(Component);
